import React, { useState } from 'react';
import {  useUserContext } from '../../../context/user_context/UserContext';
import { Loading } from '../../../components/loading/Loading';
import { Stack } from 'react-bootstrap';
import Profile from '../Profile/Profile';
import AppSidebar from '../../../components/navbar/DesktopAppSidebar';
import ImageUploadModal from '../../../components/image_upload_modal/ImageUploadModal';
import { ImageUploadType } from '../../../components/image_upload_modal/ImageUploadType';
import { StringKeys } from '../../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import { Typography, Card, CardContent } from '@mui/material';
import AvailabilityTable from '../../../components/availability/AvailabilityTable';

function Home() {
    const { firebaseUser } = useUserContext()
    const [showAddProfilePictureModal, setShowAddProfilePictureModal] = useState(false)
    const { t } = useTranslation();

    return (
        <>
            <AppSidebar
                content={
                    <>
                        <Stack gap={4}>
                            <Stack direction='horizontal' gap={3}>
                                {firebaseUser.profile_picture_url ? (
                                    <img src={firebaseUser.profile_picture_url} alt="Profile" style={{
                                        width: '80px',
                                        height: '80px',
                                        objectFit: 'cover',
                                        cursor: "pointer"
                                    }}
                                        onClick={() => { setShowAddProfilePictureModal(true); } } />
                                ) : (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        width: '80px',
                                        height: '80px',
                                        cursor: "pointer"
                                    }}
                                        onClick={() => { setShowAddProfilePictureModal(true); } }
                                    >
                                        {firebaseUser.first_name[0].toUpperCase()}{firebaseUser.last_name[0].toUpperCase()}
                                    </div>
                                )}

                                <Typography variant="h5">{firebaseUser.first_name} {firebaseUser.last_name}</Typography>
                            </Stack>
                            <div>
                                <Profile />
                            </div>
                            {firebaseUser.availability && (
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h5" gutterBottom>{t(StringKeys.AVAILABILITY)}</Typography>
                                        <AvailabilityTable availability={firebaseUser.availability} />
                                    </CardContent>
                                </Card>
                            )}
                            <ImageUploadModal
                                show={showAddProfilePictureModal}
                                onHide={() => { setShowAddProfilePictureModal(false); } } 
                                modalTitle={t(StringKeys.ADD_NEW_IMAGE)}
                                itemId={firebaseUser.uid}
                                organization={firebaseUser.organization}
                                cropShape="rect"
                                uploadType={ImageUploadType.EmployeeImage}                 
                            />                            
                        </Stack>
                    </>
                }
            />
        </>
    );
}

export default Home;